import { Star } from '@mui/icons-material'
import { Tooltip } from '@mui/material'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { getI18n, useTranslation } from 'react-i18next'
import { ILinkedSkill, IProjectFormPackage } from '../../../interfaces/projects/IProjects'
import { useStore } from '../../../Provider'
import { Data, OPNewTable } from '../../OPcomponents/OPNewTable'
import EditPubProject from './newpubproject/EditPubProject'
import { formatDateFi } from './workHistoryHelpers'

const PublicWorkHistoryTable = (props: { rowId: number | undefined }): JSX.Element => {
  const { rowId } = props
  const rootStore = useStore()
  const { t } = useTranslation()
  const { validatedUser } = rootStore.loginStore
  const { getUserProjectTitle, projects, getDetailedUserProjects } = rootStore.projectStore
  const { filteredPublicWorkHistories } = rootStore.personStore

  const tableRows: Data[] = []

  const onRowClickHandler = async (id: number | string) => {
    const clickedProject = projects.find((proj) => proj.project.projectId === id)
    if (clickedProject?.project) {
      const userDetails = await getDetailedUserProjects(validatedUser, clickedProject.project.projectId ?? -1)
      const projectUsers = await getUserProjectTitle(clickedProject.project.projectId ?? -1)

      const projectInfo: IProjectFormPackage = {
        project: clickedProject.project,
        userHas: clickedProject.userHas ?? false,
        projectUsers: projectUsers,
        userDetails: {
          details: userDetails,
          projectOwner: userDetails.projectOwner !== 0,
        },
      }
      return projectInfo as IProjectFormPackage
    }
  }

  filteredPublicWorkHistories.forEach((work) => {
    tableRows.push({
      ['key']: work.projectId,
      ['id']: work.projectId,
      rows: {
        [t('Projects.ProjectName')]: { text: work.projectName, width: '32%' },
        [t('WorkHistory.Customer')]: { text: work.customer, width: '22%' },
        [t('Projects.ProjectStartDate')]: { text: formatDateFi(work.startDate), width: '10%' },
        [t('Projects.ProjectEndDate')]: { text: formatDateFi(work.endDate), width: '10%' },
        [t('WorkHistory.Expirience')]: {
          text: `${work.daysWorked || 0} ${t('Date.ExperienceDays')}`,
          width: '8%',
          align: 'right' as const,
        },
        [t('Projects.KeyProject')]: {
          text: work.isKeyProject ? <Star color='primary' /> : '',
          width: '9%',
          align: 'center' as const,
        },
        [t('WorkHistory.Skills')]: {
          text: (
            <Tooltip
              title={work.linkedSkills
                .map((s: ILinkedSkill) => (getI18n().language === 'en' && s.skillNameEng?.length ? s.skillNameEng : s.skillNameFi))
                .join(', ')}
              placement='bottom'
              arrow
            >
              <span>{work.linkedSkills.length}</span>
            </Tooltip>
          ),
          width: '5%',
          align: 'right' as const,
        },
        [t('WorkHistory.Roles')]: {
          text: (
            <Tooltip
              title={
                work.roles?.map((r) => (getI18n().language === 'en' && r.roleNameEng?.length ? r.roleNameEng : r.roleNameFi)).join(', ') ||
                ''
              }
              placement='bottom'
              arrow
            >
              <span>{work.roles?.length || 0}</span>
            </Tooltip>
          ),
          width: '5%',
          align: 'right' as const,
        },
      },
    })
  })

  return tableRows.length ? (
    <OPNewTable
      rows={tableRows}
      curLength={tableRows.length}
      profileclickedId={rowId}
      onRowClick={onRowClickHandler}
      FormBase={EditPubProject}
    />
  ) : (
    <span>{t('WorkHistory.NoPublicWorkHistory')}</span>
  )
}

export default observer(PublicWorkHistoryTable)
